/** True when guest mode runs without Firebase Anonymous (API calls omit auth token). */
let localGuestOnly = false;

export function enableLocalGuestSession() {
  localGuestOnly = true;
}

export function disableLocalGuestSession() {
  localGuestOnly = false;
}

export function isLocalGuestSession() {
  return localGuestOnly;
}
